import {IManipulationSwiper} from '../manipulationSwiper/IManipulationSwiper';
import SupplierCard from '../supplierCard/SupplierCard';

export const SupplierSelect = ({
    enableMode,
    options,
    selectedItem,
    setSelectedItem,
}: IManipulationSwiper) => {
    return (
        <div className="w-full flex justify-start gap-4 overflow-x-auto">
            {options.map((s, index) => {
                return (
                    <SupplierCard
                        key={index}
                        className={`p-4 cursor-pointer border transition-transform duration-150 ${selectedItem?.financialSupplierId === s.financialSupplierId ? 'border-[#BBA57A] !bg-[#F4F0EA] shadow-sm' : 'border-none'} ${!enableMode ? 'pointer-events-none opacity-50' : ''}`}
                        img={s.logoUrl}
                        title={s.financialSupplierTitle}
                        onClick={() => setSelectedItem(s)}
                    />
                );
            })}
        </div>
    );
};
